import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { LEGAL } from "./legalContent";

export default function LegalPage({ type }) {
  const data = LEGAL[type];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  if (!data) return null;

  return (
    <div className="min-h-screen bg-slate-900 text-white">
      {/* Header */}
      <header className="border-b border-slate-800/60 bg-slate-900/80 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="legal-home-link">
            <img src="/maktran-mark.png" alt="Maktran Cyber logo" className="h-9 w-auto mr-3" />
            <span className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Maktran Cyber
            </span>
          </Link>
          <Link
            to="/"
            className="flex items-center text-slate-300 hover:text-white transition-colors text-sm"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl sm:text-5xl font-bold mb-2">
            <span className="bg-gradient-to-r from-blue-400 to-red-500 bg-clip-text text-transparent">
              {data.title}
            </span>
          </h1>
          <p className="text-slate-400 mb-10">{data.updated}</p>

          <div className="space-y-8">
            {data.sections.map((s, i) => (
              <section key={i} data-testid={`legal-section-${i}`}>
                <h2 className="text-xl font-semibold text-blue-400 mb-2">{s.h}</h2>
                <p className="text-slate-300 leading-relaxed">{s.p}</p>
              </section>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-slate-800 flex flex-wrap gap-6 text-sm">
            <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-slate-400 hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/" className="text-slate-400 hover:text-white transition-colors">Home</Link>
          </div>
        </motion.div>
      </main>

      <footer className="border-t border-slate-800 py-8 text-center text-slate-500 text-sm">
        &copy; 2026 Maktran Cyber. All rights reserved.
      </footer>
    </div>
  );
}
